module.exports = __webpack_public_path__ + "img/turk4.7cf000b1.jpg";